import React, {useState, useEffect} from 'react'
import { Token, config, ServerUrl, ImagesUrl, PortalType, userCode, API_URL } from './include';
import { Alerts } from './notify';
import axios from 'axios'
import Cookies from 'js-cookie'
import { decrypt } from './authentication';
import { compare, globalId, longDate } from './globalFunction';

import { useDispatch, useSelector } from 'react-redux';

const Header = ()=>{

    const dispatch = useDispatch()
    const [notice, setNotice] = useState({
        isLoading : false,
        isDataFetching: false
	});
    const [isFull, setIsFull] = useState(false)
    const [cart, setCart] = useState({
        totalItem:0,
        price:0
    });
/* Get the element you want displayed in fullscreen */ 
var elem = document.documentElement;

const IsFullMode =()=>{
     const windowWidth = window.innerWidth * window.devicePixelRatio;
    const windowHeight = window.innerHeight * window.devicePixelRatio;
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    if (((windowWidth/screenWidth)>=0.95) && ((windowHeight/screenHeight)>=0.95)) {
        closeFullscreen()
        return true;
    }
    else {
        openFullscreen()
        return false
    } 
}


/* Function to open fullscreen mode */
function openFullscreen() {
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.mozRequestFullScreen) { /* Firefox */
    elem.mozRequestFullScreen();
  } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) { /* IE/Edge */
    elem = window.top.document.body; //To break out of frame in IE
    elem.msRequestFullscreen();
  }
  setIsFull(true);
}

/* Function to close fullscreen mode */
function closeFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    window.top.document.msExitFullscreen();
  }
  setIsFull(false);
}

//#404E67

const [users, setUsers] = useState([])
const [noticeboard, setNoticeboard]=useState([])
const [currentSession, setCurrentSession] = useState('')

const fetchNoticeBoard =()=>{
    var today = new Date().toISOString().slice(0,10);
    var sql ="Select  imageUrl, description, dateCreate, ID, createdBy from tbl_noticeboard where status ='Active' and receiver = 'Only Student' or receiver = 'Everyone' and  expiry >= '"+today+"'"
    const fd = new FormData();
    fd.append("sql", sql);
    
    let url = API_URL+'/exam/result/fetch_raw'
    axios.post(url, fd, config).then(result=>{ 
        if(result.data.data.length!==0){
        setNoticeboard(result.data.data)
        }
    })
    .catch((error)=>{
        Alerts('Error!', 'danger', error.message)
    })

}


const  handleFetchData =()=>{

    var sql ="Select  startYear from tbl_school_session where status ='Active'"
    const fd = new FormData();
    fd.append("sql", sql);
    let url = API_URL+'/exam/result/fetch_raw'
    axios.post(url, fd, config)
    .then(result => {
        if(result.data.length!==0){
        setCurrentSession(result.data.data[0].startYear)
    }
    })
    .catch((error)=>{
        Alerts('Error!', 'danger', JSON.stringify(error.message)) 
    })
    }


const fetchContent =()=>{

    if(Cookies.get('kapkauscd')){
        setNotice({...notice, userCode:userCode})
    var sql ="Select familyName as fullname from tbl_family where code  ='"+userCode+"'";
     
    if(PortalType==='Student'){
       sql ="Select passport, 	studentName as fullname, gender from tbl_students where code  ='"+userCode+"'";
    }else if(PortalType==='Applicant'){
        sql ="Select passport, email_address, fullname, gender from tbl_agent where code ='"+userCode+"'";
    }


    const fd = new FormData();
    fd.append("sql", sql);
    let url = API_URL+'/exam/result/fetch_raw'
    axios.post(url, fd, config).then(result=>{ 
        if(Array.isArray(result.data.data)){
            setUsers(result.data.data[0])
        }else{
            window.location.href='/logout'
        }
        
    })
    .catch((error)=>{
        Alerts('Error!', 'danger', error.message)
        window.location.href='/logout'
    })
    
    }else{
        window.location.href='/logout'
    }
}
const fetchSidebar = async()=>{
    var sql ="Select  parent from tbl_navigation"
    const fd = new FormData();
    fd.append("sql", sql);
    let url = API_URL+'/exam/result/fetch_raw'
   await axios.post(url, fd, config).then(result=>{ 
        if(result.data.data.length!==0){

            let response = JSON.parse(result.data.data[0].parent).sort(compare)

             dispatch({
        type:'SET_RECORDS',
        name:'sidebar',
        data:response
    })
        }
    })

}


const lockScreen =()=>{
    if (localStorage.getItem("plcksr") === null) {
        localStorage.setItem('plcksr', 'islk');
      }
      document.getElementById('openlockscreenModal').click()

}

/* 
const fetchCart =()=>{
       
    let orderId = globalId()
    var sql ="Select o.ID, p.productName, count(*) as total from tbl_product_orders o, tbl_products p where o.productCode = p.code and o.orderId = '"+ orderId+"' " ;
        
    const fd = new FormData();
    fd.append("sql", sql);
    
    let url = API_URL+'/exam/result/fetch_raw'
    axios.post(url, fd, config).then(result=>{ 
        var total = 0 
      setCart({
          totalItem:result.data.data[0].total,
          price:0,
      })
    })
    .catch((error)=>{
        Alerts('Error!', 'danger', error.message)
    })

} */

useEffect(()=>{
   
    fetchNoticeBoard()
    handleFetchData()
    fetchContent()
    fetchSidebar()
    },[]);
    return <>        
<nav className="navbar header-navbar pcoded-header no-print" header-theme="theme1" style={{backgroundColor:'#404E67', color:'#ffffff'}}>
    <div className="navbar-wrapper no-print">

        <div className="navbar-logo ">
            <a className="mobile-menu" id="mobile-collapse" href="#!">
                <i className="feather icon-menu"></i></a>
            <a href="#!">
                <img className="img-fluid " style={{width:'180px'}} src={ImagesUrl+'/linelogo.png'} alt="school Logo" />
            </a>
            <a href="#!" className="mobile-options">
                <i className="feather icon-more-horizontal"></i>
            </a>
        </div>

        <div className="navbar-container container-fluid ">
            <ul className="nav-left" >
               

                <li>
                <a href="#!" style={{color:'white'}} onClick={!isFull?()=>openFullscreen():()=>IsFullMode()} >
                        <i className={`feather ${!isFull?'icon-maximize':'icon-minimize'} full-screen`} ></i>
                    </a> 
                </li>
                <li ><span style={{color:'#ffffff'}}><i className="feather icon-briefcase"></i> Current Session Is {currentSession}</span>
                </li>
            </ul>

            <ul className="nav-right no-print">
                

           {cart.totalItem>0? <li className="header-notification" onClick={()=>window.open('/tuckshop/checkout', '_self')}>
                    <div className="dropdown-primary dropdown">
                        <div className="dropdown-toggle" data-toggle="dropdown">
                            <i className="feather icon-shopping-cart"></i>
                            <span className="badge bg-c-pink">{cart.totalItem}</span>
                        </div>
                        
                    </div>
                </li>:[]}

            {noticeboard.length!==0?  <li className="header-notification">
                    <div className="dropdown-primary dropdown">
                        <div className="dropdown-toggle" data-toggle="dropdown">
                            <i className="feather icon-bell"></i>
                            <span className="badge bg-c-pink">{noticeboard.length}</span>
                        </div>
                        <ul className="show-notification notification-view dropdown-menu" data-dropdown-in="fadeIn" data-dropdown-out="fadeOut">
                            <li>
                                <h6>Noticeboard</h6>
                                <label className="label label-danger">New</label>
                            </li>
                            {noticeboard.length!==0 ? noticeboard.slice(0,4).map((data, id)=>
                            <li key={id} onClick={()=>window.open('/noticeboard', '_self')}>
                                <div className="media">
                                <img className="d-flex align-self-center img-radius" src={ImagesUrl+'/noticeboard/'+data.imageUrl} alt="sender " onError={(e)=>{e.target.onerror = null; e.target.src=ImagesUrl+"/no.jpg"}} />
                                    <div className="media-body">
                                    <h5 className="notification-user">{data.createdBy}</h5>
                            <p className="notification-msg" dangerouslySetInnerHTML={{__html:data.description.slice(0,40)+'...'}} ></p>
                                        <span className="notification-time">{longDate(data.dateCreate)}</span>
                                    </div>
                                </div>
                            </li>
                            ):''}
                        
                        </ul>
                    </div>
                </li>:''}
              
                <li className="user-profile header-notification">
                    <div className="dropdown-primary dropdown">
                        <div className="dropdown-toggle" data-toggle="dropdown">
                            
                            <span>{users.fullname}</span>
                            <i className="feather icon-chevron-down"></i>
                        </div>
                        <ul className="show-notification profile-notification dropdown-menu" data-dropdown-in="fadeIn" data-dropdown-out="fadeOut">
                        <li><a href="/change_password"><i className="feather icon-settings"></i> Change Password</a></li>
                          
                          
                            <li>
    
                            <a href="#!" onClick={lockScreen}>
                        <i className="feather icon-lock"></i> Lock Screen
                    </a>
                            </li>
                            <li>
                                <a href="/logout">
                                    <i className="feather icon-log-out"></i> Logout
                                </a>
                            </li>
                        </ul>

                    </div>
                </li>
            </ul>
        </div>
    </div>
</nav>

    </>
}
export default React.memo(Header)